<template>
  <div class="philia">
    <v-container fluid class="py-0">
      <v-row>
        <v-col cols="12" class="pt-0 px-0">
          <div class="philia-intro">
            <div class="philia-content">
              Creemos que un mundo más verde y más limpio resulta siempre inspirador, y nuestra misión y pasión son facilitarte el llevar a casa o lugar de trabajo, un poco (…o mucho) de esa verde inspiración.
              <div class="philia-content-logo">
                <v-img src="@/assets/img/logos/ph-icon.svg"></v-img>
              </div>
            </div>

            <div class="philia-intro-arrow text-center" @click="$vuetify.goTo(segundoBloque)">
              <v-img src="@/assets/img/iconos/flecha-abajo.svg"></v-img>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container id="segundoBloque">
      <v-row>
        <v-col cols="12" md="6">
          <div class="hidden-md-and-up philia-padding-textos">
            <p>La pasión que sentimos por las plantas hace que nos tomemos nuestro trabajo muy enserio; esto comienza con el estudio de las tendencias en diseño marcadas por l@s mejores diseñador@s y nuestra asociación con los viveros más tecnificados y confiables, y continúa con las mejores prácticas de producción propia, la selección experta y diligente de cada ejemplar y un riguroso cuidado en nuestros centros de operación y durante el reparto y la entrega.</p>
          </div>
          <div>
            <v-img src="@/assets/img/philia-1.jpg"></v-img>
          </div>
        </v-col>
        <v-col cols="12" md="6" class="align-self-center">
          <div class="philia-padding-textos">
            <p
              class="hidden-sm-and-down"
            >La pasión que sentimos por las plantas hace que nos tomemos nuestro trabajo muy enserio; esto comienza con el estudio de las tendencias en diseño marcadas por l@s mejores diseñador@s y nuestra asociación con los viveros más tecnificados y confiables, y continúa con las mejores prácticas de producción propia, la selección experta y diligente de cada ejemplar y un riguroso cuidado en nuestros centros de operación y durante el reparto y la entrega.</p>

            <p>La limpieza de macetas y herramental, el aseguramiento de la calidad de todos los ingredientes y la misma preparación de los sustratos, así como el cuidado de la salud de las raíces y las prácticas de sembrado, riego y fertilización, son algunas de las actividades en nuestro check list de todos los días.</p>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6" class="align-self-center" order="1" order-md="0">
          <div class="philia-padding-textos">
            <p>Durante la entrega, nos aseguramos de que sea un experto quien se encargue de transportar las plantas y entregarlas con cuidado en tu dirección o la de a quienes envías un regalo, para explicarte de primera mano y con detalle, todo lo que necesites saber de tu nuevos roommates verdes.</p>
          </div>
        </v-col>
        <v-col cols="12" md="6" order="0" order-md="1">
          <div style="height: 100%">
            <div class="philia-carousel-column">
              <template v-if="carousel_principal%2 ==0">
                <transition name="fade">
                  <v-img v-bind:src="imagen1" style="transition:.5s background-image ease; "></v-img>
                </transition>
              </template>
              <template v-else-if="carousel_principal%2==1">
                <transition name="fade">
                  <v-img v-bind:src="imagen3" style="transition:.5s background-image ease; "></v-img>
                </transition>
              </template>
              <!-- <v-carousel
                :hide-delimiter-background="true"
                :show-arrows="false"
                :hide-delimiters="true"
                cycle
                :interval="2000"
                height="calc(100vh - 416px)"
              >
                <v-carousel-item
                  v-for="(imagen, img) in imagenesCarousel"
                  :key="img"
                  :src="imagen.src"
                  transition="fade-transition"
                  reverse-transition="fade-transition"
                >
                </v-carousel-item>
              </v-carousel>-->
            </div>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6" order="0">
          <div>
            <v-img src="@/assets/img/philia-contactanos.jpg"></v-img>
          </div>
        </v-col>

        <v-col cols="12" md="6" order="1" class="align-self-center">
          <div class="philia-padding-textos">
            <p>En Chlorophilia estamos para ayudarte, ya sea en la selección de la planta ideal, responder a preguntas concretas o simplemente compartirnos nuestra pasión con ideas, consejos o experiencias.</p>

            <div class="mt-10">
              <span class="d-block titulo mb-5">No dudes en contactarnos en:</span>
              <ul class="px-0 philia-ul-contacto" style="list-style:none;">
                <li>
                  <a href="tel:8112107201" class="philia-tel">tel. 811 210 7201</a>
                </li>
                <li>
                  <span>|</span>
                </li>
                <li>
                  <a
                    href="mailto:hello@chlorophilia.com"
                    class="philia-email"
                  >hello@chlorophilia.com</a>
                </li>
              </ul>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import imagen1 from "@/assets/img/camioneta.jpg";
import imagen2 from "@/assets/img/philia-1.jpg";
import imagen3 from "@/assets/img/isometrico.jpg";

export default {
  data() {
    return {
      segundoBloque: "#segundoBloque",
      carousel_principal: 0,
      imagen1,
      imagen3
      // imagenesCarousel: [
      //   {
      //     src: imagen1
      //   },
      //   {
      //     src: imagen2
      //   }
      // ]
    };
  },
  mounted: function() {
    //emitir evento para ocultarc menú
    this.$emit("updateMenu", 0);
    gtag('config', 'UA-163902944-1', {
      'page_title' : 'Philia en Chlorophilia',
      'page_path': '/philia'
    });
  },
  created: function() {
    setInterval(() => {
      this.carousel_principal++;
    }, 6000);
  }
};
</script>